import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { ClassificationType } from "@evergis/api";
import { ClassificationQuery, goToClassification } from "../../../ducks/location/location";
import {
  getAttributeNameFromClassified,
  isParameterByAttribute,
} from "../../../evergis/core/classification/getFromClassified";
import { useSegmentChildren } from "../../../modules/Style/hooks/useSegmentChildren";
import { ClassificationParameter } from "../../../interfaces/classification";
import { ClassifiedParameterValue } from "../../../interfaces/style";
import { ClassificationCondition } from "../../../evergis/core/condition/ClassificationCondition";

export const useSymbolClassificationEdit = (): VoidFunction => {
  const dispatch = useDispatch();
  const segmentChildren = useSegmentChildren();

  return useCallback(() => {
    const condition = new ClassificationCondition(segmentChildren?.[0]?.condition);
    const field = condition.attributeName;
    const goToParams: ClassificationQuery = {
      field,
      parameter: "symbol",
      count: segmentChildren?.length,
    };

    if (condition.isUnique()) {
      goToParams.type = ClassificationType.Unique;
    }

    field && dispatch(goToClassification(goToParams));
  }, [segmentChildren, dispatch]);
};

export const useClassificationEdit = (
  name: ClassificationParameter,
  value?: ClassifiedParameterValue,
  valueIndex?: number,
): VoidFunction => {
  const dispatch = useDispatch();

  return useCallback(() => {
    if (isParameterByAttribute(value)) {
      const field = getAttributeNameFromClassified(value.values);
      const goToParams: ClassificationQuery = { field, parameter: name, count: value.values.length };

      if (value.values?.[0] && new ClassificationCondition(value.values[0].condition).isUnique()) {
        goToParams.type = ClassificationType.Unique;
      }

      if (valueIndex !== undefined) {
        goToParams.valueIndex = valueIndex;
      }

      field && dispatch(goToClassification(goToParams));
    }
  }, [dispatch, name, value, valueIndex]);
};
